import { render, staticRenderFns } from "./CertificationEditorModal.vue?vue&type=template&id=5e5749c7&"
import script from "./CertificationEditorModal.vue?vue&type=script&lang=js&"
export * from "./CertificationEditorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports